import { createAsyncThunk } from "@reduxjs/toolkit"
import { APIClient } from '../../helpers/api_helper';
const AxiosClient = new APIClient()

export const getAllRoles = createAsyncThunk('roles/all', async () => {
  const response = await AxiosClient.get('/role', {perPage: 20})
  // console.log("data dev",response)
  return response
})